(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["more-designs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;

    var track = section.querySelector('.more-designs__track');
    if (!track) return;

    /* ---- Shared state ---- */
    var isActive = false;
    var startX = 0;
    var scrollStart = 0;
    var velX = 0;
    var lastX = 0;
    var lastTime = 0;
    var rafId = null;
    var totalDrag = 0;
    var isTouchDevice = false;

    /* Momentum config */
    var FRICTION = 0.94;        /* Higher = longer glide (0.92 snappy, 0.96 very floaty) */
    var TOUCH_FRICTION = 0.95;  /* Slightly more glide on touch for that buttery feel */
    var MIN_VEL = 0.3;
    var TOUCH_MULTIPLIER = 1.8; /* Amplifies flick velocity on touch */

    /* Smooth momentum with eased deceleration */
    var currentScroll = 0;
    var targetScroll = 0;
    var isAnimating = false;

    function clampScroll(val) {
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(val, max));
    }

    function stopMomentum() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      isAnimating = false;
      velX = 0;
    }

    function animateMomentum() {
      var friction = isTouchDevice ? TOUCH_FRICTION : FRICTION;
      velX *= friction;

      if (Math.abs(velX) < MIN_VEL) {
        stopMomentum();
        return;
      }

      targetScroll = clampScroll(targetScroll + velX);

      /* Lerp for extra smoothness: ease toward target instead of snapping */
      currentScroll += (targetScroll - currentScroll) * 0.35;
      track.scrollLeft = currentScroll;

      /* Stop if we hit edges */
      if (targetScroll <= 0 || targetScroll >= track.scrollWidth - track.clientWidth) {
        velX *= 0.5; /* Kill velocity faster at edges */
      }

      rafId = requestAnimationFrame(animateMomentum);
    }

    function startMomentum() {
      if (Math.abs(velX) > MIN_VEL) {
        isAnimating = true;
        currentScroll = track.scrollLeft;
        targetScroll = currentScroll;
        rafId = requestAnimationFrame(animateMomentum);
      }
    }

    /* ---- Touch events (mobile) ---- */
    track.addEventListener('touchstart', function(e) {
      isTouchDevice = true;
      stopMomentum();
      isActive = true;
      startX = e.touches[0].clientX;
      scrollStart = track.scrollLeft;
      velX = 0;
      lastX = startX;
      lastTime = performance.now();
      totalDrag = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isActive) return;

      var x = e.touches[0].clientX;
      var now = performance.now();
      var dx = lastX - x;
      var dt = now - lastTime;

      /* Track velocity from recent movement */
      if (dt > 0) {
        velX = (dx / dt) * 16 * TOUCH_MULTIPLIER;
      }

      totalDrag += Math.abs(dx);
      lastX = x;
      lastTime = now;

      /* Directly move scroll position while touching */
      track.scrollLeft = scrollStart + (startX - x);

      /* Prevent vertical page scroll when swiping horizontally */
      if (totalDrag > 8) {
        e.preventDefault();
      }
    }, { passive: false });

    track.addEventListener('touchend', function(e) {
      if (!isActive) return;
      isActive = false;

      /* Boost velocity if the flick was fast (short touch + high vel) */
      var timeSinceStart = performance.now() - lastTime;
      if (timeSinceStart < 100 && Math.abs(velX) > 2) {
        velX *= 1.3;
      }

      startMomentum();
    }, { passive: true });

    track.addEventListener('touchcancel', function() {
      isActive = false;
      stopMomentum();
    }, { passive: true });

    /* ---- Pointer events (desktop mouse drag) ---- */
    track.addEventListener('pointerdown', function(e) {
      if (e.pointerType === 'touch') return;
      isTouchDevice = false;
      stopMomentum();
      isActive = true;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      velX = 0;
      lastX = e.pageX;
      lastTime = performance.now();
      totalDrag = 0;
      track.setPointerCapture(e.pointerId);
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('pointermove', function(e) {
      if (!isActive || e.pointerType === 'touch') return;
      var x = e.pageX;
      var now = performance.now();
      var dt = now - lastTime;
      var dx = lastX - x;

      if (dt > 0) {
        velX = (dx / dt) * 16;
      }

      totalDrag += Math.abs(dx);
      lastX = x;
      lastTime = now;
      track.scrollLeft = scrollStart + (startX - x);
    });

    function endPointer(e) {
      if (!isActive || e.pointerType === 'touch') return;
      isActive = false;
      track.style.cursor = '';
      startMomentum();
    }

    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);

    /* Prevent click if user was dragging */
    track.addEventListener('click', function(e) {
      if (totalDrag > 6) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
